import fetch from 'utils/fetch'

export const getOperationList = params => {
    return fetch({
        url: '/operation/list',
        data: { ...params },
    })
}
